/**
 * Vendor role enum values. Keep in sync with backend `modules/vendor/models/vendor.js`.
 */
export const VendorRole = Object.freeze({
  SUPPLIER: 'SUPPLIER',
  SERVICE_PROVIDER: 'SERVICE_PROVIDER',
  CONSULTANT: 'CONSULTANT',
  CREDIT_CARD_ISSUER: 'CREDIT_CARD_ISSUER',
  BANK: 'BANK',
  LENDER: 'LENDER',
  LANDLORD: 'LANDLORD',
  UTILITY_PROVIDER: 'UTILITY_PROVIDER',
  INSURANCE_PROVIDER: 'INSURANCE_PROVIDER',
  GOVERNMENT_AGENCY: 'GOVERNMENT_AGENCY',
  PAYROLL_PROVIDER: 'PAYROLL_PROVIDER',
  SHIPPING_CARRIER: 'SHIPPING_CARRIER',
  TAX_AUTHORITY: 'TAX_AUTHORITY',
  OTHER: 'OTHER',
});

export const VENDOR_ROLE_LABELS = Object.freeze({
  [VendorRole.SUPPLIER]: 'Supplier',
  [VendorRole.SERVICE_PROVIDER]: 'Service Provider',
  [VendorRole.CONSULTANT]: 'Consultant',
  [VendorRole.CREDIT_CARD_ISSUER]: 'Credit Card Issuer',
  [VendorRole.BANK]: 'Bank',
  [VendorRole.LENDER]: 'Lender',
  [VendorRole.LANDLORD]: 'Landlord',
  [VendorRole.UTILITY_PROVIDER]: 'Utility Provider',
  [VendorRole.INSURANCE_PROVIDER]: 'Insurance Provider',
  [VendorRole.GOVERNMENT_AGENCY]: 'Government Agency',
  [VendorRole.PAYROLL_PROVIDER]: 'Payroll Provider',
  [VendorRole.SHIPPING_CARRIER]: 'Shipping Carrier',
  [VendorRole.TAX_AUTHORITY]: 'Tax Authority',
  [VendorRole.OTHER]: 'Other',
});

export const VENDOR_ROLES_FOR_SELECT = Object.freeze(
  Object.entries(VENDOR_ROLE_LABELS).map(([value, label]) => ({
    value,
    label,
  }))
);

export const VENDOR_ROLE_FILTER_OPTIONS = Object.freeze([
  { value: '', label: 'All' },
  ...VENDOR_ROLES_FOR_SELECT,
]);

export function getVendorRoleLabel(value) {
  if (!value) {
    return '';
  }
  return VENDOR_ROLE_LABELS[value] || value;
}
